// HEADER Search
document.addEventListener("DOMContentLoaded", () => {
  function setupPredictiveSearch(inputId, resultsId) {
    const input = document.getElementById(inputId);
    const results = document.getElementById(resultsId);
    let controller;

    if (!input || !results) return;

    input.addEventListener("input", function () {
      const query = this.value.trim();

      if (query.length < 2) {
        results.innerHTML = "";
        results.setAttribute("aria-expanded", "false");
        return;
      }

      if (controller) controller.abort();
      controller = new AbortController();

      fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,page,article`, {
        signal: controller.signal
      })
      .then(res => res.json())
      .then(data => {
        results.innerHTML = "";
        results.setAttribute("aria-expanded", "true");

        const items = [];

        data.resources.results.products.forEach(product => {
          items.push(`
            <div class="predictive-search-item">
              <a href="${product.url}">
                <img src="${product.image}" width="40" alt="${product.title}" />
                <span>${product.title}</span>
              </a>
            </div>
          `);
        });

        if (items.length === 0) {
          results.innerHTML = '<div class="predictive-search-item">No results found</div>';
        } else {
          results.innerHTML = items.join("");
        }
      })
      .catch((error) => {
        if (error.name !== 'AbortError') {
          console.error("Predictive search error:", error);
        }
      });
    });

    // Close on outside click
    document.addEventListener("click", (e) => {
      if (!e.target.closest(`#${inputId}`)) {
        results.innerHTML = "";
        results.setAttribute("aria-expanded", "false");
      }
    });
  }

  // Init both desktop and mobile
  setupPredictiveSearch("predictive-search-input-desktop", "predictive-search-results-desktop");
  setupPredictiveSearch("predictive-search-input-mobile", "predictive-search-results-mobile");
});